<div [style]="rootdivstyle">
  <div class="flex flex-col lg:flex-row justify-end w-screen h-screen">
    <div class="lg:absolute lg:-left-24">
      <img alt="Login Background Image" class="z-10 lg:h-screen mix-blend-overlay pointer-events-none" [src]="localStorage.getItem('loginBackgroundUrl')"/>
    </div>
    <div class="bg-white h-[65%] w-screen lg:w-[65%] lg:h-screen z-20">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
